export interface MenuItemType {
    label: string;
    value: string;
}

export interface MenuGroupType extends MenuItemType {
    expanded?: boolean;
}
